<div class="modal-content">
    <div class="modal-header">
        <h3>{{ 'Thank you for reporting a new batch billing case to us.' | translate }}</h3>
        <div class="modal-close">
            <img class="cross-close" src="/content/icons/Close-Black.svg" (click)="navigateToHome()">
        </div>
    </div>
    <div class="modal-body" >
        <div class="modal-body-content">
            <span class="main-section">
              <p>{{'Our backoffice center will verify and handle the case as soon as possible. When the case is verified by us you will be able to access and update it under the menu case and in the tab open.' | translate}}</p>
              <p>{{'Your invoice has been submitted together with the case and can accessed when the case has been verified.' | translate }}</p>
                <br /><br />
                {{ 'You can navigate to home using the button below.' | translate }}
            </span>
        </div>
    </div>

    <div class="modal-footer">
      <button mat-stroked-button type="button" class="secondary" (click)="navigateToEconomyAdmin()">{{ 'Go to admin tab' | translate }}</button>
      <button mat-stroked-button type="button" ngbAutofocus class="primary" (click)="navigateToHome()">{{ 'Go to home' | translate }}</button>
    </div>
</div>
